import { styled } from "styled-components";
import { radius } from "@libertify/ui";

export const AvatarImage = styled.img`
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: ${radius.box}px;
`;
